import type { ReactNode } from 'react';
import { useTheme } from '@/app/providers/ThemeProvider';
import { SkipLink } from '@/components/a11y/skip-link';
import { RouteAnnouncer } from '@/components/a11y/route-announcer';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { MobileSidebarProvider } from './MobileSidebarContext';

interface AppShellProps {
  children: ReactNode;
  fullBleed?: boolean;
}

export function AppShell({ children, fullBleed = false }: AppShellProps) {
  const { theme, mode, preferredMode } = useTheme();

  return (
    <MobileSidebarProvider>
      <div data-theme="bosch" data-mode={preferredMode} className="flex flex-col h-dvh">
        <SkipLink />
        <Header />
        <div className="flex flex-1 overflow-hidden relative">
          <Sidebar />
          <main
            id="main-content"
            tabIndex={-1}
            data-theme={theme}
            data-mode={mode}
            className={
              fullBleed
                ? 'flex-1 flex flex-col overflow-hidden bg-[var(--bg-primary)] text-[var(--text-primary)]'
                : 'flex-1 overflow-y-auto bg-[var(--bg-primary)] text-[var(--text-primary)]'
            }
          >
            {fullBleed ? (
              children
            ) : (
              <div className="mx-auto max-w-[1200px] px-4 py-4 md:px-8 md:py-6">{children}</div>
            )}
          </main>
        </div>
        <Footer />
        <RouteAnnouncer />
      </div>
    </MobileSidebarProvider>
  );
}
